import React from 'react';

export interface Image {
  title: string;
  imageType?: string;
  transforms: Record<string, {
    url: string;
    width: string;
    height: string;
  }>;
}

interface PictureProps {
  image: Image;
  defaultTransform: string;
  loading: 'lazy' | 'eager';
  classes?: string | undefined;
  pictureClasses?: string | undefined;
}

export default function Picture(
  {
    image,
    defaultTransform,
    loading,
    classes,
    pictureClasses,
  }: PictureProps,
) {
  const media = {
    all: '',
    xxs: '(max-width: 412px)',
    xs: '(max-width: 575px)',
    sm: '(max-width: 767px)',
    'md-min': '(min-width: 768px)',
    md: '(max-width: 991px)',
    lg: '(max-width: 1023px)',
    xl: '(max-width: 1199px)',
    '2xl': '(max-width: 1535px)',
    '3xl-min': '(min-width: 1536px)',
    '3xl': '(max-width: 1767px)',
    '4xl': '(min-width: 1768px)',
    '4k': '(min-width: 3840px)',
  };

  return (
    image && (
      <picture className={pictureClasses}>
        {Object.entries(media).map(([key, value]) => (
          (image.transforms[key]) && (
            <source
              media={value}
              srcSet={image.transforms[key]?.url}
              key={key}
              width={image.transforms[key]?.width}
              height={image.transforms[key]?.height}
            />
          )
        ))}
        <img
          src={image.transforms[defaultTransform]?.url}
          alt=""
          loading={loading}
          width={image.transforms[defaultTransform]?.width}
          height={image.transforms[defaultTransform]?.height}
          className={classes}
        />
      </picture>
    )
  );
}
